var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHpGoodscolorchangeActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#006EFF;}\r\n\t.st1{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1188.4,689.9c-18.9-47.2-46.9-90.2-82.4-126.5C1033.4,489,936,448,831.7,448l0,0 C619.6,448.2,447.8,620.2,448,832.3s172.2,383.9,384.3,383.7c42.3,0,84.3-7.1,124.3-20.8c21.7-7.5,38.7-21.6,49-40.8 c18.9-35.9,11.5-80-18-107.9c-16.1-14.8-36.7-22.6-59.6-22.6h-0.3c-17.7,0-32-14.3-32-32s14.3-32,32-32h166.1 c66.1,0.1,120.2-52.5,122-118.6C1217.1,789.6,1207.8,738,1188.4,689.9z M639.7,960c-35.3,0-64-28.7-64-64s28.7-64,64-64 s64,28.7,64,64S675,960,639.7,960z M703.7,768c-35.3,0-64-28.7-64-64s28.7-64,64-64s64,28.7,64,64S739,768,703.7,768z M895.7,704 c-35.3,0-64-28.7-64-64s28.7-64,64-64s64,28.7,64,64S931,704,895.7,704z M1023.7,832c-35.3,0-64-28.7-64-64s28.7-64,64-64 s64,28.7,64,64v0C1087.7,803.3,1059,832,1023.7,832L1023.7,832z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440,512H288c-17.7,0-32,14.3-32,32v192c0,17.7,14.3,32,32,32h88c4.4,0,8-3.6,8-8v-48c0-4.4-3.6-8-8-8h-56 V576h120c4.4,0,8-3.6,8-8v-48C448,515.6,444.4,512,440,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M754.3,370.3l-45.7-45.6c-3-3-7.1-4.7-11.3-4.7H576v-64h48c8.8,0,16-7.2,16-16V80c0-8.8-7.2-16-16-16H272 c-8.8,0-16,7.2-16,16v160c0,8.8,7.2,16,16,16h48v64H198.6c-4.2,0-8.3,1.7-11.3,4.7L68.7,443.3c-3,3-4.7,7.1-4.7,11.3v370.7 c0,4.2,1.7,8.3,4.7,11.3l118.6,118.6c3,3,7.1,4.7,11.3,4.7H376c4.4,0,8-3.6,8-8v-48c0-4.4-3.6-8-8-8H218.5L128,805.5v-331 l90.5-90.5h530.2c4.4,0,8-3.6,8-8C756.7,373.9,755.8,371.8,754.3,370.3z M320,128h256v64H320V128z M384,320v-64h128v64H384z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHpGoodscolorchangeActive);
export default __webpack_public_path__ + "static/media/hp_goodscolorchange_active.84c4a76474f144e9346aebac84bcc2d3.svg";
export { ForwardRef as ReactComponent };